import { render, staticRenderFns } from "./ServiceVisitBoardColumn.vue?vue&type=template&id=265e26ee&scoped=true&"
import script from "./ServiceVisitBoardColumn.vue?vue&type=script&lang=js&"
export * from "./ServiceVisitBoardColumn.vue?vue&type=script&lang=js&"
import style0 from "./ServiceVisitBoardColumn.vue?vue&type=style&index=0&id=265e26ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "265e26ee",
  null
  
)

export default component.exports